import PowerIcon from './PowerIcon'

export default PowerIcon
